import type { User } from '@/types/Types'
import { getDb } from './offlineDb'

const STORE_NAME = 'userProgress'

export async function saveUserProgress(user: User) {
  const db = await getDb()
  // Sanitize user object to ensure it is serializable
  const serializableUser = JSON.parse(JSON.stringify(user))
  await db.put(STORE_NAME, serializableUser)
}

export async function loadUserProgress(userId: string): Promise<User | undefined> {
  const db = await getDb()
  return db.get(STORE_NAME, userId)
}

export async function clearUserProgress(userId: string) {
  const db = await getDb()
  await db.delete(STORE_NAME, userId)
}
